module.exports = __webpack_public_path__ + "m-b-logo-c2294f8d.png";